import { call } from '../@';

type Payload = { transactionId: string; placeholderId?: string; removedUserId?: string };

export default async function syncTransaction(payload: Payload) {
	return await call('transaction-sync', payload);
}
